import {
  StyledSelect
} from "./chunk-RWT4HETL.mjs";
import {
  ErrorFilled_default
} from "./chunk-EOMCCNMZ.mjs";
import {
  ChevronDown_default
} from "./chunk-LRTFI6YS.mjs";

// src/components/select/select-trigger.tsx
import React, { forwardRef } from "react";
var SelectTrigger = forwardRef(
  function SelectTrigger2({ clearable, children, ...rest }, ref) {
    return /* @__PURE__ */ React.createElement(StyledSelect.Control, { ...rest }, /* @__PURE__ */ React.createElement(StyledSelect.Trigger, { ref }, children), /* @__PURE__ */ React.createElement(StyledSelect.IndicatorGroup, null, clearable && /* @__PURE__ */ React.createElement(StyledSelect.ClearTrigger, null, /* @__PURE__ */ React.createElement(ErrorFilled_default, null)), /* @__PURE__ */ React.createElement(StyledSelect.Indicator, null, /* @__PURE__ */ React.createElement(ChevronDown_default, null))));
  }
);

export {
  SelectTrigger
};
